import { Switch, Tooltip } from "@deligoo/ui"
import clsx from "clsx"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"

import { Card } from "@/components/Card"
import { updateDriver } from "@/store/drivers"
import { Driver } from "@/types"
import { DriverUtils, fetchSetDriverActivity } from "@/utils"

import cls from "../../DriverPanel.module.scss"

export const StatusSection = ({ driver }: { driver: Driver }) => {
  const [isDriverStatusUpdating, setIsDriverStatusUpdating] = useState(false)

  const dispatch = useDispatch()

  const { t } = useTranslation()

  async function handleActivityChange() {
    try {
      setIsDriverStatusUpdating(true)

      const {
        response,
        json: { data: updatedDriver },
      } = await fetchSetDriverActivity(driver.id, { is_available: !driver.is_available })

      if (!response.ok) throw response

      if (updatedDriver) dispatch(updateDriver(updatedDriver))

      toast.success(t("drivers:activity_change_success"))
    } catch (error) {
      toast.error(t("drivers:activity_change_fail"))
    } finally {
      setIsDriverStatusUpdating(false)
    }
  }

  return (
    <Card.Section className={cls.status}>
      <div>
        Status kuriera
        <div className={clsx(cls.value, driver.is_available && "text-success")}>
          {driver.is_available ? t("drivers:active") : t("drivers:offline")}
          {driver.availability_changed_at && DriverUtils.formatAvailability(driver.availability_changed_at)}
        </div>
      </div>

      <Tooltip content="Przełącz status kuriera" placement="left" theme="light">
        <div>
          <Switch
            size="small"
            onClick={handleActivityChange}
            defaultChecked={driver.is_available}
            disabled={isDriverStatusUpdating}
          />
        </div>
      </Tooltip>
    </Card.Section>
  )
}
